<template>
  <div v-if="!edit" class="inline-flex flex-col gap-y-2">
    <template v-if="value">
      <rpm-button
          @click="download"
          label="Visualizar arquivo"
          :loading="isDownloading"
      ></rpm-button>

      <rpm-button
          @click="deleteFile"
          icon="fa fa-trash"
          class="px-2 rounded-md"
          color="red"
          v-if="procedure.in_progress"
      ></rpm-button>

      <div v-if="value.file.coordinates" class="text-sm mt-1 flex items-center">
        <i class="fa-solid fa-location-dot mr-1 text-red-500"></i>
        Coordenadas: {{ value.file.coordinates }}
      </div>
    </template>

    <span v-else class="text-sm">
      Sem resposta
    </span>
  </div>

  <FileAnswer
      v-else
      v-bind="$attrs"
      no-label
      :question="original"
      @update-detail="updateModelValue"
  />
</template>

<script>
import FileAnswer from '#views/questionnaire/answers/FileAnswer';

export default {
  name: "FileDetail",
  inheritAttrs: false,
  components: {
    FileAnswer
  },
  props: {
    value: {
      required: true
    },
    procedure: {
      type: Object
    },
    original: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isDownloading: false,
    };
  },
  methods: {
    download() {
      if (!this.value || this.isDownloading) {
        return;
      }

      this.isDownloading = true;

      this.$store.dispatch("downloadFile", { url: this.value.file.signed_url })
          .then((response) => {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(
                new Blob([response.data], { type: response.headers['content-type'] })
            );
            link.download = this.value.file.file_name;
            document.body.appendChild(link);
            link.click();
            link.remove();
          })
          .catch(() => {
            this.$notify('Não foi possível realizar o download do arquivo.', 'error');
          })
          .finally(() => {
            this.isDownloading = false;
          });
    },
    deleteFile() {
      this.$store.dispatch("deleteFile", {
        file_path: this.value.file.file_path,
        file_name: this.value.file.file_name,
        procedure: this.procedure.id
      }).then(() => {
        this.$notify('Arquivo excluído com sucesso', 'success');
        this.$emit('deleted');
      }).catch(() => {
        this.$notify('Não foi possível excluir o arquivo.', 'error');
      });
    },
    updateModelValue(val) {
      this.$emit("update:modelValue", val);
    }
  },
  watch: {
    value(newer) {
      // this.updateModelValue(newer);
    }
  },
  mounted() {
    // this.updateModelValue(this.value);
  }
}
</script>

<style scoped>
</style>
